export function getLocale() {
    return navigator.language || "pl-PL";
}

export function getTimezoneName() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
    } catch (e) {
        console.error(e);
        return "UTC";
    }
}
